// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconHardwareServerServerStored_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M16 5V7.6822C15.7166 7.25594 15.3801 6.86799 15 6.52778V6H14.3178C13.3684 5.36874 12.2289 5.00068 11.0034 5L16 5Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M4 6 7.6822 6C8.63163 5.36874 9.77114 5.00068 10.9966 5L4.37114e-7 5 8.74229e-8 9 5.34141 9C5.46488 8.65069 5.61977 8.31622 5.80269 8H4L4 6ZM1 7C1 6.44771 1.44772 6 2 6 2.55229 6 3 6.44771 3 7 3 7.55228 2.55229 8 2 8 1.44772 8 1 7.55228 1 7ZM0 10 5.08296 10C5.0284 10.3252 5 10.6593 5 11L4 11 4 13H5.34141C5.46488 13.3493 5.61977 13.6838 5.80269 14L.00000278158 14 0 10ZM1 12C1 11.4477 1.44772 11 2 11 2.55229 11 3 11.4477 3 12 3 12.5523 2.55229 13 2 13 1.44772 13 1 12.5523 1 12ZM5.24537e-7 4 16 4V0H.00000278158L5.24537e-7 4ZM2 .999997C1.44772.999997 1 1.44771 1 2 1 2.55228 1.44772 3 2 3 2.55229 3 3 2.55228 3 2 3 1.44771 2.55229.999997 2 .999997ZM15 .999999H4L4 3H15V.999999Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M11 16C8.23858 16 6 13.7614 6 11C6 8.23858 8.23858 6 11 6C13.7614 6 16 8.23858 16 11C16 13.7614 13.7614 16 11 16ZM11 14.5L14 10.5H11.85L11.85 7.65088H10.15L10.15 10.5L8 10.5L11 14.5Z" class="svg-bg"/>
</svg>
`;
/**
 * IconHardwareServerServerStored is a generated icon component.
 */
let IconHardwareServerServerStored = IconHardwareServerServerStored_1 = class IconHardwareServerServerStored extends IconBaseElement {
    render() {
        return html `${IconHardwareServerServerStored_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconHardwareServerServerStored.icons = new Map([
    ['s8', _s16IconSvg],
    ['s12', _s16IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s16IconSvg],
    ['s32', _s16IconSvg],
    ['s40', _s16IconSvg],
    ['s48', _s16IconSvg],
    ['s64', _s16IconSvg],
    ['s72', _s16IconSvg],
    ['s80', _s16IconSvg],
]);
IconHardwareServerServerStored = IconHardwareServerServerStored_1 = __decorate([
    customElement('zui-icon-hardware-server-server-stored')
], IconHardwareServerServerStored);
export { IconHardwareServerServerStored };
